// ─── ABA: ATIVIDADES (cross-modulo, vinculadas a este negocio) ───────────
// Onda 2 (2026-06-02): migrado pra Antd — Button + Empty + Typography + Divider.
import { useEffect, useState } from 'react';
import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import {
  Button, Typography, Empty, Spin, App as AntApp,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { API_URL } from '../../config';
import { getToken } from '../../utils/auth';
import { ModalAtividade, STATUS_LABEL, PRIORIDADE_LABEL, type Atividade } from '../Atividades';
import type { Negocio } from './types';
import { ItemAtividadeNegocio } from './ItemAtividadeNegocio';

export { STATUS_LABEL, PRIORIDADE_LABEL };
export type { Atividade };

export function AbaAtividades({ negocioId, negocio, reloadFlag }: {
  negocioId: number; negocio: Negocio; reloadFlag: number;
}) {
  const { message } = AntApp.useApp();
  const [atividades, setAtividades] = useState<Atividade[]>([]);
  const [loading, setLoading] = useState(true);
  const [editando, setEditando] = useState<Atividade | null>(null);
  const [novo, setNovo] = useState(false);
  const [meuEmail, setMeuEmail] = useState('');

  useEffect(() => {
    (async () => {
      const session = await fetchAuthSession();
      const email = ((session.tokens?.idToken?.payload as any)?.email || '').toLowerCase();
      setMeuEmail(email);
    })();
  }, []);

  useEffect(() => { carregar(); }, [negocioId, reloadFlag]);
  async function carregar() {
    setLoading(true);
    try {
      const token = await getToken();
      const r = await axios.get(
        `${API_URL}/atividades?escopo=origem&origem_modulo=comercial&origem_id=${negocioId}`,
        { headers: { Authorization: token } });
      const data = r.data?.body ? JSON.parse(r.data.body) : r.data;
      setAtividades(Array.isArray(data) ? data : []);
    } catch (e: any) {
      message.error('Erro: ' + (e.response?.data?.error || e.message));
      setAtividades([]);
    } finally { setLoading(false); }
  }

  // Pre-atribuicao: vendedor responsavel do negocio.
  const presetVendedor = (negocio as any).vendedor_email
    ? [{ email: (negocio as any).vendedor_email.toLowerCase(), papel: 'responsavel' }]
    : [];
  const origemPreset = {
    origem_modulo: 'comercial',
    origem_tipo: 'proposta',
    origem_id: String(negocioId),
    origem_label: negocio.titulo || `Negócio #${negocioId}`,
    atribuicoes: presetVendedor,
  };

  const pendentes = atividades.filter(a => a.status === 'pendente' || a.status === 'em_andamento');
  const concluidas = atividades.filter(a => a.status === 'concluida' || a.status === 'cancelada');

  async function mudarStatusAtividade(id: string, status: string) {
    try {
      const token = await getToken();
      await axios.post(`${API_URL}/atividades`,
        { action: 'update', id, status },
        { headers: { Authorization: token } });
      carregar();
    } catch (e: any) {
      message.error('Erro: ' + (e.response?.data?.error || e.message));
    }
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {atividades.length} atividade{atividades.length === 1 ? '' : 's'} — {pendentes.length} aberta{pendentes.length === 1 ? '' : 's'}
        </Typography.Text>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => setNovo(true)}>
          Nova atividade
        </Button>
      </div>

      {loading ? (
        <div style={{ padding: 40, textAlign: 'center' }}><Spin /></div>
      ) : atividades.length === 0 ? (
        <Empty
          description={
            <Typography.Text type="secondary">
              Nenhuma atividade vinculada a este negócio.<br />
              <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                Crie uma pra registrar próximos passos, ou peça ao Dwight:{' '}
                <em>"crie atividade nesse negócio pra revisar preço com cliente"</em>.
              </Typography.Text>
            </Typography.Text>
          }
        />
      ) : (
        <>
          {pendentes.length > 0 && (
            <>
              <Typography.Text strong style={{ fontSize: 11, color: '#666', textTransform: 'uppercase', letterSpacing: 1, display: 'block', marginBottom: 8 }}>
                Em aberto
              </Typography.Text>
              {pendentes.map(a => (
                <ItemAtividadeNegocio key={a.id} atividade={a} meuEmail={meuEmail}
                  onAbrir={() => setEditando(a)}
                  onMudarStatus={(s) => mudarStatusAtividade(a.id, s)} />
              ))}
            </>
          )}
          {concluidas.length > 0 && (
            <>
              <Typography.Text strong style={{ fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: 1, display: 'block', marginTop: 18, marginBottom: 8 }}>
                Histórico
              </Typography.Text>
              {concluidas.map(a => (
                <ItemAtividadeNegocio key={a.id} atividade={a} meuEmail={meuEmail}
                  onAbrir={() => setEditando(a)}
                  onMudarStatus={(s) => mudarStatusAtividade(a.id, s)} />
              ))}
            </>
          )}
        </>
      )}

      {(editando || novo) && (
        <ModalAtividade
          atividade={editando}
          meuEmail={meuEmail}
          origemPreset={origemPreset}
          onClose={() => { setEditando(null); setNovo(false); }}
          onSalvo={() => { setEditando(null); setNovo(false); carregar(); }}
        />
      )}
    </div>
  );
}
